module.exports = __webpack_public_path__ + "static/img_0943-3614b5ce60d76de21a6be06d77f469dc.webp";